export default [
    [
        {realValue: 'Confirmations', value: 'exchangeCategory._1'},
        {realValue: 'Reports', value: 'exchangeCategory._2'},
        {realValue: 'Templates', value: 'exchangeCategory._3'},
        {realValue: 'Analysis', value: 'exchangeCategory._4'},
        {realValue: 'TOD sample', value: 'exchangeCategory._5'}
    ],
    [
        {realValue: 'Group Audit Instructions', value: 'exchangeCategory._6'},
        {realValue: 'Group Accounting Manual', value: 'exchangeCategory._7'},
        {realValue: 'Specific instructions', value: 'exchangeCategory._8'},
        {realValue: 'Documentation for procedures performed at group level', value: 'exchangeCategory._9'},
        {realValue: 'Deliverables submission', value: 'exchangeCategory._10'}
    ],
    [
        {realValue: 'Guidelines', value: 'exchangeCategory._11'},
        {realValue: 'Instructions', value: 'exchangeCategory._12'}
    ]
]